export enum CreateGroupMode {
	ALL_USERS = 'ALL_USERS',
	SELECTED_USERS = 'SELECTED_USERS',
}
